<div class="content-wrapper">
  <div class="content-header">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="content-body">
    <section class="form-control-repeater">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <form [formGroup]="eventForm">
              <div class="card-header d-flex flex-column align-items-start pb-0">
                <h4 class="card-title">معلومات الفعالية الأساسية</h4>
                <div class="d-flex align-items-center mt-50">
                  <span class="mr-1 font-weight-bold">حالة الفعالية (نشط)</span>
                  <label class="my-switch">
                    <input
                      type="checkbox"
                      id="isActive"
                      formControlName="isActive"
                    />
                    <span class="my-slider"></span>
                  </label>
                </div>
              </div>
              <div class="card-body">
                <!-- Basic Event Info -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="nameAr"
                        >اسم الفعالية (عربي)
                        <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="nameAr"
                        formControlName="nameAr"
                        placeholder="ادخل اسم الفعالية (عربي)"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('nameAr')?.hasError('required') &&
                          eventForm.get('nameAr')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('nameAr')?.hasError('arabicOnly') &&
                          eventForm.get('nameAr')?.touched
                        "
                      >
                        يُسمح بإدخال النص العربي فقط
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="nameEn"
                        >اسم الفعالية (إنجليزي)
                        <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="nameEn"
                        formControlName="nameEn"
                        placeholder="ادخل اسم الفعالية (إنجليزي)"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('nameEn')?.hasError('required') &&
                          eventForm.get('nameEn')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('nameEn')?.hasError('englishOnly') &&
                          !eventForm.get('nameEn')?.hasError('required')
                        "
                      >
                        يُسمح بإدخال النص الإنجليزي فقط
                      </small>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="country"
                        >البلد <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="country"
                        formControlName="country"
                        placeholder="ادخل البلد"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('country')?.hasError('required') &&
                          eventForm.get('country')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="city"
                        >المكان <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="city"
                        formControlName="city"
                        placeholder="ادخل المكان"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('city')?.hasError('required') &&
                          eventForm.get('city')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="categoryId"
                        >فئة الفعالية <span class="text-danger">*</span></label
                      >
                      <select
                        class="form-control"
                        id="categoryId"
                        formControlName="categoryId"
                      >
                        <option value="">اختر الفئة</option>
                        <option
                          *ngFor="let type of eventType"
                          [value]="type.id"
                        >
                          {{ type.eventType }}
                        </option>
                      </select>
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('categoryId')?.hasError('required') &&
                          eventForm.get('categoryId')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="address"
                        >العنوان <span class="text-danger">*</span></label
                      >
                      <!-- <select
                        class="form-control"
                        id="categoryId"
                        formControlName="categoryId"
                      >
                        <option value="">اختر الفئة</option>
                        <option
                          *ngFor="let type of eventType"
                          [value]="type.id"
                        >
                          {{ type.eventType }}
                        </option>
                      </select> -->
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        formControlName="address"
                        placeholder="ادخل العنوان"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('address')?.hasError('required') &&
                          eventForm.get('address')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="longitude"
                        >الخط الطولي (longitude)<span class="text-danger"
                          >*</span
                        ></label
                      >
                      <input
                        type="number"
                        class="form-control"
                        id="longitude"
                        formControlName="longitude"
                        placeholder="ادخل الخط الطولي"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('longitude')?.hasError('required') &&
                          eventForm.get('longitude')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="latitude"
                        >الخط العرضي (latitude)
                        <span class="text-danger">*</span></label
                      >
                      <!-- <select
                        class="form-control"
                        id="categoryId"
                        formControlName="categoryId"
                      >
                        <option value="">اختر الفئة</option>
                        <option
                          *ngFor="let type of eventType"
                          [value]="type.id"
                        >
                          {{ type.eventType }}
                        </option>
                      </select> -->
                      <input
                        type="number"
                        class="form-control"
                        id="latitude"
                        formControlName="latitude"
                        placeholder="ادخل الخط العرضي"
                      />
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('latitude')?.hasError('required') &&
                          eventForm.get('latitude')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="description"
                        >الوصف <span class="text-danger">*</span></label
                      >
                      <textarea
                        class="form-control"
                        id="description"
                        rows="3"
                        formControlName="description"
                        placeholder="ادخل الوصف الخاص بالحدث"
                      ></textarea>
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('description')?.hasError('required') &&
                          eventForm.get('description')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="policy"
                        >سياسة الفعالية
                        <span class="text-danger">*</span></label
                      >
                      <textarea
                        class="form-control"
                        id="policy"
                        rows="3"
                        formControlName="policy"
                        placeholder="ادخل سياسة الفعالية"
                      ></textarea>
                      <small
                        class="text-danger"
                        *ngIf="
                          eventForm.get('policy')?.hasError('required') &&
                          eventForm.get('policy')?.touched
                        "
                      >
                        هذا الحقل مطلوب
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Image Uploads -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >صورة الغلاف <span class="text-danger">*</span></label
                      >
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="eventCover"
                          (change)="onFileSelected($event, 'eventCover')"
                        />
                        <label class="custom-file-label" for="eventCover"
                          >اختر صورة الغلاف</label
                        >
                      </div>
                      <div class="mt-2" *ngIf="previewUrl2">
                        <img
                          [src]="previewUrl2"
                          class="img-thumbnail"
                          style="max-height: 200px"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        >الصورة الرئيسية
                        <span class="text-danger">*</span></label
                      >
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="eventImage"
                          (change)="onFileSelected($event, 'eventImage')"
                        />
                        <label class="custom-file-label" for="eventImage"
                          >اختر الصورة الرئيسية</label
                        >
                      </div>
                      <div class="mt-2" *ngIf="previewUrl1">
                        <img
                          [src]="previewUrl1"
                          class="img-thumbnail"
                          style="max-height: 200px"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Event Schedules -->
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-header">
                        <h4 class="card-title">مواعيد الفعالية</h4>
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          (click)="addEventSchedule()"
                        >
                          إضافة موعد جديد
                        </button>
                      </div>
                      <div class="card-body">
                        <div formArrayName="eventSchedules">
                          <div
                            *ngFor="
                              let schedule of eventSchedules.controls;
                              let i = index
                            "
                            [formGroupName]="i"
                            class="mb-3 p-3 border rounded"
                          >
                            <div class="row">
                              <div class="col-md-5">
                                <div class="form-group">
                                  <label
                                    >وقت البدء
                                    <span class="text-danger">*</span></label
                                  >
                                  <input
                                    type="datetime-local"
                                    class="form-control"
                                    formControlName="startTime"
                                  />
                                  <small
                                    class="text-danger"
                                    *ngIf="
                                      eventSchedules
                                        .at(i)
                                        .get('startTime')
                                        ?.hasError('required') &&
                                      eventSchedules.at(i).get('startTime')
                                        ?.touched
                                    "
                                  >
                                    هذا الحقل مطلوب
                                  </small>
                                  <small
                                    class="text-danger"
                                    *ngIf="
                                      eventSchedules
                                        .at(i)
                                        .hasError('startTimeInPast') &&
                                      eventSchedules.at(i).get('startTime')
                                        ?.touched
                                    "
                                  >
                                    وقت البدء يجب ان يكون بعد الوقت الحالي
                                  </small>
                                </div>
                              </div>
                              <div class="col-md-5">
                                <div class="form-group">
                                  <label
                                    >وقت الانتهاء
                                    <span class="text-danger">*</span></label
                                  >
                                  <input
                                    type="datetime-local"
                                    class="form-control"
                                    formControlName="endTime"
                                  />
                                  <small
                                    class="text-danger"
                                    *ngIf="
                                      eventSchedules
                                        .at(i)
                                        .get('endTime')
                                        ?.hasError('required') &&
                                      eventSchedules.at(i).get('endTime')
                                        ?.touched
                                    "
                                  >
                                    هذا الحقل مطلوب
                                  </small>
                                  <small
                                    class="text-danger"
                                    *ngIf="
                                      eventSchedules
                                        .at(i)
                                        .hasError('invalidDateRange')
                                    "
                                  >
                                    وقت الانتهاء يجب أن يكون بعد وقت البدء
                                  </small>
                                </div>
                              </div>
                              <div class="col-md-2 d-flex align-items-end">
                                <button
                                  type="button"
                                  class="btn btn-sm btn-danger"
                                  (click)="removeEventSchedule(i)"
                                >
                                  حذف
                                </button>
                              </div>
                            </div>
                            <div class="form-check mt-2">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                formControlName="isCenematic"
                                id="cinematicCheck{{ i }}"
                              />
                              <label
                                class="form-check-label"
                                for="cinematicCheck{{ i }}"
                              >
                                فعاليه سينمائيه
                              </label>
                            </div>
                            <div
                              *ngIf="schedule.get('isCenematic')?.value"
                              class="row"
                            >
                              <ng-container
                                *ngIf="!editMode"
                                formArrayName="hallRowSeatDistribution"
                              >
                                <ng-container
                                  [formGroupName]="rowNumber"
                                  *ngFor="
                                    let row of getHallRowSeatDistribution(i)
                                      .controls;
                                    let rowNumber = index
                                  "
                                >
                                  <div class="col-md-5">
                                    <div class="form-group">
                                      <label
                                        >رقم الصف
                                        <span class="text-danger"
                                          >*</span
                                        ></label
                                      >
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder="ادخل رقم الصف"
                                        readonly
                                        [value]="rowNumber + 1"
                                      />
                                      <small
                                        class="text-danger"
                                        *ngIf="
                                          eventSchedules
                                            .at(i)
                                            .get('rowNumber')
                                            ?.hasError('required') &&
                                          eventSchedules.at(i).get('rowNumber')
                                            ?.touched
                                        "
                                      >
                                        هذا الحقل مطلوب
                                      </small>
                                    </div>
                                  </div>

                                  <div class="col-md-5">
                                    <div class="form-group">
                                      <label
                                        >عدد المقاعد
                                        <span class="text-danger"
                                          >*</span
                                        ></label
                                      >
                                      <input
                                        type="number"
                                        class="form-control"
                                        formControlName="seats"
                                        placeholder="ادخل عدد المقاعد"
                                      />
                                      <small
                                        class="text-danger"
                                        *ngIf="
                                          eventSchedules
                                            .at(i)
                                            .get('rowNumber')
                                            ?.hasError('required') &&
                                          eventSchedules.at(i).get('rowNumber')
                                            ?.touched
                                        "
                                      >
                                        هذا الحقل مطلوب
                                      </small>
                                    </div>
                                  </div>

                                  <div class="col-md-2 d-flex align-items-end">
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-danger"
                                      (click)="removeRowNumber(i)"
                                    >
                                      حذف
                                    </button>
                                  </div>
                                </ng-container>
                              </ng-container>

                              <ng-container
                                *ngIf="editMode"
                                formArrayName="hallRowSeatDistribution"
                              >
                                <ng-container
                                  [formGroupName]="rowNumber"
                                  *ngFor="
                                    let row of getHallRowSeatDistributionForEdit(
                                      i
                                    ).controls;
                                    let rowNumber = index
                                  "
                                >
                                  <div class="col-md-5">
                                    <div class="form-group">
                                      <label
                                        >رقم الصف
                                        <span class="text-danger"
                                          >*</span
                                        ></label
                                      >
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder="ادخل رقم الصف"
                                        readonly
                                        [value]="rowNumber + 1"
                                      />
                                      <small
                                        class="text-danger"
                                        *ngIf="
                                          eventSchedules
                                            .at(i)
                                            .get('rowNumber')
                                            ?.hasError('required') &&
                                          eventSchedules.at(i).get('rowNumber')
                                            ?.touched
                                        "
                                      >
                                        هذا الحقل مطلوب
                                      </small>
                                    </div>
                                  </div>

                                  <div class="col-md-5">
                                    <div class="form-group">
                                      <label
                                        >عدد المقاعد
                                        <span class="text-danger"
                                          >*</span
                                        ></label
                                      >
                                      <input
                                        type="number"
                                        class="form-control"
                                        formControlName="seats"
                                        placeholder="ادخل عدد المقاعد"
                                      />
                                      <small
                                        class="text-danger"
                                        *ngIf="
                                          eventSchedules
                                            .at(i)
                                            .get('rowNumber')
                                            ?.hasError('required') &&
                                          eventSchedules.at(i).get('rowNumber')
                                            ?.touched
                                        "
                                      >
                                        هذا الحقل مطلوب
                                      </small>
                                    </div>
                                  </div>

                                  <div class="col-md-2 d-flex align-items-end">
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-danger"
                                      (click)="removeRowNumber(i)"
                                    >
                                      حذف
                                    </button>
                                  </div>
                                </ng-container>
                              </ng-container>

                              <div class="col-md-12 mt-3">
                                <button
                                  *ngIf="!editMode"
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  (click)="addRowNumber(i)"
                                >
                                  + إضافة صف جديد
                                </button>

                                <button
                                  *ngIf="editMode"
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  (click)="addEditRowNumber(i)"
                                >
                                  + إضافة صف جديد
                                </button>
                              </div>
                            </div>

                            <!-- Ticket Types -->
                            <div class="row mt-2">
                              <div class="col-12">
                                <h5>أنواع التذاكر</h5>
                                <div formArrayName="eventTicketsTypes">
                                  <!-- <div *ngFor="let ticket of getTicketTypes(i).controls; let j = index" [formGroupName]="j" class="mb-2 p-2 border rounded"></div> -->
                                  <div
                                    *ngFor="
                                      let ticket of getTicketTypes(i).controls;
                                      let j = index
                                    "
                                    [formGroupName]="j"
                                    class="mb-2 p-2 border rounded"
                                  >
                                    <div class="row">
                                      <div class="col-md-3">
                                        <div class="form-group">
                                          <label
                                            >اسم التذكرة
                                            <span class="text-danger"
                                              >*</span
                                            ></label
                                          >
                                          <input
                                            type="text"
                                            class="form-control"
                                            formControlName="name"
                                          />
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('name')
                                                ?.hasError('required') &&
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('name')?.touched
                                            "
                                          >
                                            هذا الحقل مطلوب
                                          </small>
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('name')
                                                ?.hasError(
                                                  'duplicateTicketName'
                                                )
                                            "
                                          >
                                            اسم التذكرة موجود مسبقاً
                                          </small>
                                        </div>
                                      </div>
                                      <div class="col-md-2">
                                        <div class="form-group">
                                          <label
                                            >السعر
                                            <span class="text-danger"
                                              >*</span
                                            ></label
                                          >
                                          <input
                                            type="number"
                                            class="form-control"
                                            formControlName="price"
                                            min="0"
                                          />
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('price')
                                                ?.hasError('required') &&
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('price')?.touched
                                            "
                                          >
                                            هذا الحقل مطلوب
                                          </small>
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('price')
                                                ?.hasError('required')
                                            "
                                          >
                                            هذا الحقل مطلوب
                                          </small>
                                        </div>
                                      </div>
                                      <div
                                        *ngIf="
                                          !eventSchedules
                                            .at(i)
                                            .get('isCenematic').value
                                        "
                                        class="col-md-2"
                                      >
                                        <div class="form-group">
                                          <label
                                            >عدد التذاكر
                                            <span class="text-danger"
                                              >*</span
                                            ></label
                                          >
                                          <input
                                            type="number"
                                            class="form-control"
                                            formControlName="availableTickets"
                                            min="0"
                                          />
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('availableTickets')
                                                ?.hasError('required') &&
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('availableTickets')
                                                ?.touched
                                            "
                                          >
                                            هذا الحقل مطلوب
                                          </small>
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get('availableTickets')
                                                ?.hasError('required')
                                            "
                                          >
                                            هذا الحقل مطلوب
                                          </small>
                                        </div>
                                      </div>
                                      <div class="col-md-2">
                                        <div class="form-group">
                                          <label
                                            >الحد الأقصى للشراء
                                            <span class="text-danger"
                                              >*</span
                                            ></label
                                          >
                                          <input
                                            type="number"
                                            class="form-control"
                                            formControlName="maximumAllowedPurchasedTicketsPerCustomer"
                                            min="0"
                                          />
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get(
                                                  'maximumAllowedPurchasedTicketsPerCustomer'
                                                )
                                                ?.hasError('required') &&
                                              getTicketTypes(i)
                                                .at(j)
                                                .get(
                                                  'maximumAllowedPurchasedTicketsPerCustomer'
                                                )?.touched
                                            "
                                          >
                                            هذا الحقل مطلوب
                                          </small>
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .hasError('invalidTicketRange')
                                            "
                                          >
                                            الحد الأقصى للشراء يجب أن لا يتعدي
                                            عدد التذاكر
                                          </small>
                                          <small
                                            class="text-danger"
                                            *ngIf="
                                              getTicketTypes(i)
                                                .at(j)
                                                .get(
                                                  'maximumAllowedPurchasedTicketsPerCustomer'
                                                )
                                                ?.hasError('min')
                                            "
                                          >
                                            الحد الأقصى للشراء يجب أن لا يقل عن
                                            1
                                          </small>
                                        </div>
                                      </div>
                                      <div class="col-md-2">
                                        <div class="form-group">
                                          <label>ملاحظات</label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            formControlName="note"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="col-md-1 d-flex align-items-end"
                                      >
                                        <button
                                          type="button"
                                          class="btn btn-sm btn-danger"
                                          (click)="removeTicketType(i, j)"
                                        >
                                          حذف
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-primary mt-2"
                                  (click)="addTicketType(i)"
                                  *ngIf="
                                    !eventSchedules.at(i).get('isCenematic')
                                      .value
                                  "
                                >
                                  إضافة نوع تذكرة جديد
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Messages and Submit -->
                <div class="row mt-2">
                  <div class="col-12">
                    <!-- <div *ngIf="errorMessage" class="alert alert-danger">
                        {{errorMessage}}
                      </div>
                      <div *ngIf="successMessage" class="alert alert-success">
                        {{successMessage}}
                      </div> -->
                    <button
                      *ngIf="!editMode"
                      type="submit"
                      class="btn btn-primary"
                      [disabled]="isLoading"
                      (click)="save()"
                    >
                      <span
                        *ngIf="isLoading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      حفظ
                    </button>

                    <button
                      type="submit"
                      *ngIf="editMode"
                      class="btn btn-primary"
                      [disabled]="isLoading"
                      (click)="update()"
                    >
                      <span
                        *ngIf="isLoading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      تعديل
                    </button>
                  </div>
                </div>
            </div>
          </form>
        </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ngb-toast
  *ngIf="toastService.message"
  [autohide]="true"
  (hidden)="toastService.clear()"
  style="position: fixed; left: 30px; top: 95px"
  delay="5000"
>
  <span style="color: #3f8260">{{ toastService.message }} </span>
  <!-- <i data-feather="check" class="mr-50"></i> -->
</ngb-toast>
